import Vue from "vue";
import App from "./App.vue";
import router from "./router.js";
import axios from "axios";
import useCurrency from "./utils/useCurrency";
import store from "./store";
import i18n from "./i18n";

Vue.prototype.$http = axios;
Vue.prototype.$http.defaults.withCredentials = true;

const currencyComposable = useCurrency();

// Axios interceptor to add currency param to all requests
Vue.prototype.$http.interceptors.request.use((config) => {
  if (config.url && config.url.startsWith(process.env.VUE_APP_API)) {
    // Only add currency param to API requests
    const code = currencyComposable.getCurrencyCode();
    if (config.method === "get") {
      if (!config.params) config.params = {};
      config.params.currency = code;
    } else if (config.method === "post" || config.method === "put") {
      if (typeof config.data === "object" && config.data !== null) {
        config.data.currency = code;
      }
    }
  }
  return config;
});

global.jQuery = require("jquery");
var $ = global.jQuery;
window.$ = $;

import "./../node_modules/slick-carousel/slick/slick.css";
import "../public/css/style.scss";
import "promise-polyfill/src/polyfill";

new Vue({
  router: router,
  render: (h) => h(App),
  store,
  i18n,
}).$mount("#app");
